import { Component, HostBinding, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'suka-calendar-day-overlay',
  template: `
    <div
      *ngFor="let day of range(numberOfDays,1)"
      class="calendar-day"
      (click)="toggleDay(day)"
      [ngClass]="{
        'calendar-day--selected': days.indexOf(day) >= 0
      }"
    >
      <span class="calendar-day__number">
        {{day}}
      </span>
    </div>
  `
})
export class CalendarDayOverlay {
  @HostBinding('class.calendar-day-picker__overlay') baseClass = true;
  @Input() days: number[] = [];
  @Output() daysChange = new EventEmitter<number[]>();
  numberOfDays = 31;

  range(size, startAt = 0) {
    return [...Array(size).keys()].map(i => i + startAt);
  }

  toggleDay(day: number) {
    const indexOfDay = this.days.indexOf(day);

    if (indexOfDay < 0) {
      this.days.push(day);
    } else {
      this.days.splice(indexOfDay, 1);
    }

    this.days.sort((a, b) => {
      return a - b;
    });

    this.daysChange.emit(this.days);
  }
}
